import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFitToScreen = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeMiterlimit: 10
	},
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Laag-1",
		"serif:id": "Laag 1",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M1.78,6.997l0,-2.206c0,-1.012 0.74,-1.832 1.652,-1.832l2.969,0",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.56px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.442,21.193l-3.01,0c-0.913,0 -1.652,-0.821 -1.652,-1.832l0,-2.438",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.56px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.77,2.958l2.968,0c0.913,0 1.653,0.821 1.653,1.832l0,2.222",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.56px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22.391,16.906l0,2.455c0,1.012 -0.74,1.832 -1.652,1.832l-2.983,0",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.56px"
				}
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 6.148,
				y: 8.177,
				width: 11.706,
				height: 7.61,
				style: {
					fill: "none",
					stroke: "currentColor",
					strokeWidth: "1.56px"
				}
			})
		]
	})
});
export default SvgFitToScreen;
